import React from 'react';
import { SageClassnames } from '@kajabi/sage-react';

import './style.scss';

type Props = {
  value: string;
  maxLength: number;
  className?: string;
};

const CharacterCounter = ({ value, maxLength, className = '' }: Props) => {
  const currentLength = value ? value.length : 0;
  const remainingCharacters = maxLength - value.length;
  const errorClassName = remainingCharacters < 0 ? 'character-counter--error' : '';
  const classNames = `character-counter ${className} ${errorClassName}`;

  return (
    <p className={classNames}>
      {currentLength}/{maxLength}
    </p>
  );
};

export default CharacterCounter;
